import React from 'react';
import logo from '../logo.jpg'
const AuthLayout = ({ children, title, subtitle }) => {
  return (
    <div className="auth-page">
      <div className="container py-5">
        <div className="row align-items-center min-vh-100">
          {/* Left Branding Side */}
          <div className="col-lg-6 text-white pe-lg-5 d-none d-lg-block">
            <div className="d-flex align-items-center mb-4">
    <div className="logo-placeholder me-3">
                <img src={logo} className='rounded-circle' alt="IEEE Logo" width="75" />
              </div>             </div>
            <h1 className="display-3 fw-bold mb-4">{title}</h1>
            <p className="lead opacity-75 mb-4">{subtitle}</p>
            <p className="fw-bold">Start The Journey now !</p>
          </div>

          {/* Right Form Side */}
          <div className="col-lg-5 offset-lg-1">
            <div className="card auth-card border-0 p-4 p-md-5">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;